<div class="legend">
  <ul class="legends">
    <li
      *ngFor="let legend of legends"
      (click)="toggleSelection(legend)"
      [class.active]="legend.selected"
    >
      <div class="hint">
        <nz-icon [nzType]="legend.icon" nzTheme="outline" />
      </div>
      <div class="text">{{ legend.text }}</div>
    </li>
    @if (!allSelected) {
      <li class="!p-0">
        <button
          nz-button
          nzType="primary"
          nzSize="small"
          (click)="selectAll(); selectionChange.emit(selected)"
        >
          All
        </button>
      </li>
    }
  </ul>

  <div class="timezone">
    Calendar: {{ timeZone }} | Actual: {{ currentTimeZone }}
  </div>
</div>
